module.exports = __webpack_public_path__ + "static/la-hydro-jet-logo-572b94dd6bd18abdc7730645c14d091c.svg";